import { alpha } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useFormViewStyles = makeStyles(({ spacing, palette }) => {
  const color = palette.grey['700'];
  return createStyles({
    title: {
      backgroundColor: palette.mode === 'dark' ? palette.grey['A700'] : palette.background.paper,
      color,
      display: 'flex',
      padding: `${spacing(1.5)} ${spacing(2)} ${spacing(0.5)}`,
      marginBottom: -spacing(1.5),
      position: 'sticky',
      top: 0,
      zIndex: 2,

      '&::after': {
        borderTop: `1px solid ${alpha(color, 0.5)}`,
        flex: 1,
        height: 0,
        marginLeft: spacing(2),
        content: `' '`,
      },
    },
    line: {},
    flex: {
      display: 'flex',
    },
  });
});

export default useFormViewStyles;
